import React from "react";
import { theme } from "../../Common/Credentials";

const TabSwitch = ({
    options = [],
    value,
    onChange,
    activeTabClass = "",
    inactiveTabClass = "",
    className = "",
}) => {
    return (
        <div className={`tw-flex tw-items-center tw-gap-3 tw-gap-x-5 ${className}`}>
            <div className="tw-bg-slate-100 tw-p-1 tw-rounded-lg tw-flex tw-items-center tw-border tw-border-slate-200">
                {options.map((option) => (
                    typeof option === "string" ?
                        <button
                            key={option}
                            onClick={() => onChange(option)}
                            className={`tw-px-4 tw-py-1.5 tw-text-xs tw-uppercase tw-font-black tw-rounded tw-tracking-wide tw-transition-all tw-cursor-pointer tw-flex tw-items-center tw-outline-none tw-border-none tw-gap-1.5 ${value === option
                                ?
                                "tw-bg-white tw-text-slate-850 tw-shadow-sm tw-border tw-border-slate-200/50 tw-outline-none focus:tw-outline-none " + activeTabClass
                                : "tw-text-slate-400 tw-hover:text-slate-700 tw-outline-none focus:tw-outline-none " + inactiveTabClass
                                }`}
                        >
                            {option}
                        </button>
                        :
                        <button
                            key={option.value}
                            onClick={() => onChange(option.value)}
                            className={`tw-px-4 tw-py-1.5 tw-text-xs tw-uppercase tw-font-black tw-rounded tw-tracking-wide tw-transition-all tw-cursor-pointer tw-flex tw-items-center tw-outline-none tw-border-none tw-gap-1.5 ${value === option.value
                                ?
                                "tw-bg-white tw-text-slate-850 tw-shadow-sm tw-border tw-border-slate-200/50 tw-outline-none focus:tw-outline-none " + activeTabClass
                                : "tw-text-slate-400 tw-hover:text-slate-700 tw-outline-none focus:tw-outline-none " + inactiveTabClass
                                }`}
                        >
                            {option.label}

                            {option.count > 0 && (
                                <span
                                    className={` ${value === option.value ? (theme === "modern" ? "tw-bg-gradient-to-r tw-from-blue-600 tw-to-indigo-600" : "tw-bg-[#4d4d4d]") : "tw-bg-gray-300"} tw-text-white tw-font-black tw-text-[8px] tw-px-2 tw-py-0.5 tw-rounded-full`}
                                >
                                    {option.count}
                                </span>
                            )}
                        </button>
                ))}
            </div>
        </div>
    );
};

export default TabSwitch;